export const storage = {
  get: (key: string): string => window.localStorage.getItem(key),
  set: (key: string, val: string): void => window.localStorage.setItem(key, val),
  remove: (key: string): void => window.localStorage.removeItem(key),
};
